module.exports = __webpack_public_path__ + "img/header-4.20a99b9b.png";